interface IconProps {
  className?: string;
}

export function FolderIcon({ className = "h-5 w-5 text-folder" }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M3.5 6.5A1.5 1.5 0 0 1 5 5h4.086a1.5 1.5 0 0 1 1.06.44l1.122 1.12a1.5 1.5 0 0 0 1.06.44H19a1.5 1.5 0 0 1 1.5 1.5v8.5A1.5 1.5 0 0 1 19 18.5H5A1.5 1.5 0 0 1 3.5 17V6.5Z" />
    </svg>
  );
}

function mimeTint(mime: string): string {
  if (mime === "application/pdf") {
    return "text-file-pdf";
  }
  if (mime.startsWith("image/")) {
    return "text-file-image";
  }
  return "text-file";
}

export function FileIcon({ mime, className }: { mime: string; className?: string }) {
  const tint = mimeTint(mime);
  return (
    <svg
      className={`${className ?? "h-5 w-5"} ${tint}`}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M6 3.5h7.5L18.5 8.5V20a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5Z" />
      <path d="M13.5 3.5V8.5H18.5" />
    </svg>
  );
}
